import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useSettings } from "@/App";
import Hero from "@/components/sections/Hero";
import WhatWeSource from "@/components/sections/WhatWeSource";
import FeaturedOpportunities from "@/components/sections/FeaturedOpportunities";
import HowItWorks from "@/components/sections/HowItWorks";
import WhyGoldstone from "@/components/sections/WhyGoldstone";
import GlobalReach from "@/components/sections/GlobalReach";
import Stats from "@/components/sections/Stats";
import Team from "@/components/sections/Team";
import Affiliations from "@/components/sections/Affiliations";
import { BespokeCTA, FinalCTA } from "@/components/sections/CTAs";

export default function Home() {
  const { settings } = useSettings();
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/opportunities", { params: { featured: true } }).then((r) => setFeatured(r.data)).catch(() => {});
  }, []);

  const s = settings?.sections || {};
  const ct = settings?.content || {};

  return (
    <div data-testid="home-page">
      <Hero hero={settings?.hero} eyebrow={ct.hero_eyebrow} strip={ct.hero_strip} />
      {s.what_we_source !== false && <WhatWeSource cards={settings?.what_we_source || []} eyebrow={ct.wws_eyebrow} heading={ct.wws_heading} />}
      {s.featured !== false && <FeaturedOpportunities opportunities={featured} eyebrow={ct.featured_eyebrow} heading={ct.featured_heading} />}
      {s.stats !== false && <Stats stats={settings?.stats || []} comingSoon={settings?.stats_coming_soon} eyebrow={settings?.stats_eyebrow} heading={settings?.stats_heading} />}
      {s.how_it_works !== false && <HowItWorks content={ct.how_it_works} />}
      {s.bespoke !== false && <BespokeCTA />}
      {s.why !== false && <WhyGoldstone content={ct.why} />}
      {s.team && <Team team={settings?.team} />}
      {s.affiliations !== false && <Affiliations data={settings?.affiliations} />}
      {s.global_reach !== false && <GlobalReach content={ct.global_reach} />}
      <FinalCTA content={ct.final_cta} />
    </div>
  );
}
